import React, { useState, useEffect } from 'react';
import '@/assets/sass/style.scss';
import { Helmet } from 'react-helmet-async';
import Main from '@/components/Main';

type CurrentHostType = 'docs.nhn-commerce.com';

const App = () => {
  const [currHost, setCurrHost] = useState<CurrentHostType>(window.location.host as CurrentHostType);
  const url = `https://www.googletagmanager.com/ns.html?id=${
    currHost === 'docs.nhn-commerce.com' ? 'GTM-PRF2JS6' : 'GTM-WJVRB3F'
  }`;

  useEffect(() => {
    setCurrHost(window.location.host as CurrentHostType);
  }, []);
  return (
    <>
      <Helmet>
        <title>API 문서 – NHN Commerce</title>
        <meta name="author" content="NHN커머스" />
        <meta
          name="keywords"
          content="NHN커머스, 샵바이, 고도몰, 개발자센터, 판매자센터, 워크스페이스, 쇼핑몰제작, 쇼핑몰스킨제작, 쇼핑몰 기능개선, 쇼핑몰기능개발, 쇼핑몰개발, 샵바이워크스페이스"
        />
        <meta name="description" content="NHN 커머스에서 제공하는 API 입니다." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://img.cdn-nhncommerce.com/design/og/og_img.png" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="315" />
        <meta property="og:title" content="API 문서 – NHN Commerce" />
        <meta property="og:description" content="NHN 커머스에서 제공하는 API 입니다." />
        <meta property="og:url" content="https://www.nhn-commerce.com" />
        <meta name="twitter:title" content="API 문서 – NHN Commerce" />
        <meta name="twitter:image" content="https://img.cdn-nhncommerce.com/design/og/og_img.png" />
        <meta name="twitter:description" content="NHN 커머스에서 제공하는 API 입니다." />
      </Helmet>
      <Main />
      <noscript>
        {`<iframe src=${url} height="0" width="0" style={{ display: 'none', visibility: 'hidden' }} />`}
      </noscript>
    </>
  );
};

export default App;
